/**
 * Created by carlhaynes on 9/28/17.
 */
import React, { Component } from 'react';
import '../App.css';
import {Navbar, Nav, NavItem, NavDropdown, MenuItem} from 'react-bootstrap';
import {withRouter} from 'react-router-dom'
import {GotoPage, isAnonymous, isAuthenticated, handleLogout, isAdmin, version, auth} from "../App";

class Header extends Component {

  constructor(props) {
    super(props);

    //this.gotoHome = this.gotoHome.bind(this);

    this.state = {
      selected: 0
    };
  }


  handleSelect(selectedKey) {
    this.setState({selected:  selectedKey});

    if (selectedKey === 0) {
      this.props.history.push('/');
    } else if (selectedKey === 1) {
      this.props.history.push('/about');
    } else if (selectedKey === 2) {
      this.props.history.push('/topics');
    } else if (selectedKey === 3) {
      this.props.history.push('/login');
    } else if (selectedKey === 4) {
      handleLogout();
      this.props.history.push('/');
    } else if (selectedKey === 5) {
      this.props.history.push('/login');
    } else if (selectedKey === 6) {
      this.props.history.push('/settings');
    } else if (selectedKey === 7) {
      this.props.history.push('/profile');
    } else if (selectedKey === 8) {
        this.props.history.push('/artists');
    } else if (selectedKey === 9) {
        this.props.history.push('/artwork');
    } else {
      alert('selected ' + selectedKey);
    }
  }


  selectedState = (key) =>{
    if (key===this.state.selected) {
      return 'active';
    }
    return '';
  }

  //  gotoHome(event) {
  //   this.props.history.push("/");
  // }


  render() {
    //console.log("active: " + this.state.selected);

    return (
      <Navbar ref={(e) => this._navbar = e} inverse collapseOnSelect fixedTop>
        <Navbar.Header>
          <Navbar.Brand active>
            <a href="/" onClick={(e) => GotoPage(e, this.props, "/")}> <img src="/images/zoetrovelogo@0,25x.png" width="30" height="30" className="d-inline-block align-top" alt=""/>Zoetrove</a>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav onSelect={this.handleSelect.bind(this)}  activeKey={this.state.selected}>
            <NavItem eventKey={8} href="/artists">Artists</NavItem>
            <NavItem eventKey={9} href="/artwork">Artwork</NavItem>
          </Nav>
          <Nav pullRight onSelect={this.handleSelect.bind(this)}>
            <NavItem href="#">{version}</NavItem>
            { (isAdmin()) ?
              <NavDropdown title="Admin" id="basic-nav-dropdown">
                <MenuItem eventKey={6}>View Something</MenuItem>
              </NavDropdown>
              : ""
                }
            {(!isAuthenticated() || isAnonymous())
              ? <NavItem eventKey={3} href="/login">Login</NavItem>
              : <NavDropdown title={auth.currentUser.email} id="basic-nav-dropdown">
                <MenuItem eventKey={6}>Settings</MenuItem>
                <MenuItem eventKey={7}>Profile</MenuItem>
                  <MenuItem divider />
                <MenuItem eventKey={4}>Logout</MenuItem>
                </NavDropdown>
            }
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/Components/Header.jsx